import Head from 'next/head';
import { useAppState } from '../../../providers/AppStateProvider';

const Meta = ({ useLocalSession }: { useLocalSession: boolean }) => {
  const { hasNewMessage, isIos } = useAppState();
  return (
    <Head>
      <title>コネクト サービス</title>
      <meta
        name="viewport"
        content={
          useLocalSession || isIos
            ? 'width=device-width, initial-scale=1.0, maximum-scale=1'
            : 'width=device-width, initial-scale=1.0'
        }
      />
      <meta name="robots" content="noindex nofollow" />
      {useLocalSession && (
        <meta http-equiv="cache-control" content="no-store,no-cache" />
      )}
      <meta name="application-name" content="コネクト サービス" />
      <meta name="apple-mobile-web-app-capable" content="yes" />
      <meta name="apple-mobile-web-app-status-bar-style" content="default" />
      <meta name="apple-mobile-web-app-title" content="コネクト サービス" />
      <meta name="description" content="コネクト サービス" />
      <meta name="format-detection" content="telephone=no" />
      <meta name="mobile-web-app-capable" content="yes" />
      {/* <meta name="msapplication-config" content="/icons/browserconfig.xml" /> */}
      {/* <meta name="msapplication-TileColor" content="#2B5797" /> */}
      {/* <meta name="msapplication-tap-highlight" content="no" /> */}
      <link
        rel="apple-touch-icon"
        href="/_next/static/media/pwa/logo-192.png"
      />
      {/* 
    <link
      rel="apple-touch-icon"
      sizes="152x152"
      href="/icons/touch-icon-ipad.png"
    />
    <link
      rel="apple-touch-icon"
      sizes="180x180"
      href="/icons/touch-icon-iphone-retina.png"
    />
    <link
      rel="apple-touch-icon"
      sizes="167x167"
      href="/icons/touch-icon-ipad-retina.png"
    />

    <link
      rel="icon"
      type="image/png"
      sizes="32x32"
      href="/icons/favicon-32x32.png"
    />
    <link
      rel="icon"
      type="image/png"
      sizes="16x16"
      href="/icons/favicon-16x16.png"
    /> */}
      {/* <link rel="manifest" href="/manifest.json" /> */}
      {/* <link rel="mask-icon" href="/icons/safari-pinned-tab.svg" color="#5bbad5" /> */}
      <link rel="shortcut" href="/favicon.ico" />
      <link
        rel="icon"
        href={hasNewMessage ? '/favicon-dot.ico' : '/favicon.ico'}
      />
      {/* <link
      rel="stylesheet"
      href="https://fonts.googleapis.com/css?family=Roboto:300,400,500"
    /> */}

      <meta name="twitter:card" content="summary" />
      <meta name="twitter:url" content={process.env.NEXT_PUBLIC_DOMAIN} />
      <meta name="twitter:title" content="コネクト サービス" />
      <meta name="twitter:description" content="コネクト サービス" />
      <meta
        name="twitter:image"
        content={`${process.env.NEXT_PUBLIC_DOMAIN}/favicon.ico`}
      />
      <meta name="twitter:creator" content="アットホーム" />
      <meta property="og:type" content="website" />
      <meta property="og:title" content="コネクト サービス" />
      <meta property="og:description" content="コネクト サービス" />
      <meta property="og:site_name" content="コネクト サービス" />
      <meta property="og:url" content={process.env.NEXT_PUBLIC_DOMAIN} />
      {/* <meta
      property="og:image"
      content="https://yourdomain.com/icons/apple-touch-icon.png"
    /> */}
      {/* <link
      rel="apple-touch-startup-image"
      href="/images/apple_splash_2048.png"
      sizes="2048x2732"
    />
    <link
      rel="apple-touch-startup-image"
      href="/images/apple_splash_1668.png"
      sizes="1668x2224"
    />
    <link
      rel="apple-touch-startup-image"
      href="/images/apple_splash_1536.png"
      sizes="1536x2048"
    />
    <link
      rel="apple-touch-startup-image"
      href="/images/apple_splash_1125.png"
      sizes="1125x2436"
    />
    <link
      rel="apple-touch-startup-image"
      href="/images/apple_splash_1242.png"
      sizes="1242x2208"
    />
    <link
      rel="apple-touch-startup-image"
      href="/images/apple_splash_750.png"
      sizes="750x1334"
    />
    <link
      rel="apple-touch-startup-image"
      href="/images/apple_splash_640.png"
      sizes="640x1136"
    /> */}
    </Head>
  );
};

export default Meta;
